export enum TripStep {
  WhoStep = 0,
  WhereStep = 1,
  WhenStep = 2
}

export enum NewUserTripStep {
  WhereStep = 0,
  WhenStep = 1,
  WhoStep = 2
}
